module.exports = {"DASHBOARD":"Dashboard","DEALS":"Offers","SURVEYS":"Surveys","INVOICES":"Invoices","OFFER":"Offer's details","CHARTS":"Charts","TRANSACTIONS":"Transactions","CONTACT_US":"Contact us","CLAIMS":"Claims","SALES":"Sales"}


//////////////////
// WEBPACK FOOTER
// ./src/app/locale/en/nav.json
// module id = 346
// module chunks = 8